import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import useNotify from "../../unit/useNotify";
import NoResults from "../../unit/NoResults";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const standStatus = ($status: any): string => {
  $status = $status.toLowerCase();
  if (
    $status == "success" ||
    $status == "succeed" ||
    $status == "processed" ||
    $status == "created"
  ) {
    return "Success";
  } else if ($status == "fail" || $status == "failed") {
    return "Failed";
  }
  return $status;
};
const LoanACHLog = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  //loan/paymentschedule/current/appId
  const { data, error, isLoading, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/achlog",
    {
      id: appId,
    }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;

  const achlog = data.data;
  //change achlog to array
  const achlogData = Object.keys(achlog);
  const achlogArray = achlogData
    .map((key) => {
      return achlog[key].map((item: any) => {
        return item;
      });
    })
    .flat();

  const getRowKey = (item: any, index: number) => {
    return [
      item?.iId,
      item?.paymentId,
      item?.showtime,
      item?.sAction,
      item?.sStatus,
      index,
    ]
      .filter((value) => value !== undefined && value !== null && value !== "")
      .join("-");
  };

  return (
    <>
      <Typography gutterBottom sx={{ p: 1, pb: 0 }}>
        Date available beginning : 2023-03-01
      </Typography>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable stickyHeader id="table-loan-summary-ach-log-list">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Date
              </TableCell>
              <TableCell className="hm-table-header">Correlation ID</TableCell>
              <TableCell className="hm-table-header">Action</TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Status
              </TableCell>
              <TableCell className="hm-table-header">Note</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {achlogArray == undefined ||
            achlogArray.length == 0 ||
            achlogArray == null ? (
              <TableRow key="loan-ach-log-empty">
                <TableCell colSpan={8} className="no-results">
                  <NoResults />
                </TableCell>
              </TableRow>
            ) : (
              achlogArray.map((item: any, index: number) => (
                <TableRow key={getRowKey(item, index)}>
                  <TableCell className="dateText">{item.showtime}</TableCell>
                  <TableCell>{item.paymentId}</TableCell>
                  <TableCell>{item.sAction}</TableCell>
                  <TableCell>{standStatus(item.sStatus)}</TableCell>
                  <TableCell>
                    {item.sMsg && (
                      <>
                        {item.dAmount &&
                        item.sMsg == "Amount : " + item.dAmount ? (
                          <>Amount: {formatCurrency(item.dAmount)}</>
                        ) : (
                          <>{item.sMsg}</>
                        )}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanACHLog;
